// extracted by css-extract-rspack-plugin
export default {"stack":"Controls-module__stack___V461H","panel":"Controls-module__panel___JBDjt","held":"Controls-module__held___VG200","form":"Controls-module__form___dnkCZ"};